import { Anchor, Breadcrumbs, Progress } from '@mantine/core'

import { useLocation } from '@redwoodjs/router'

import { filterPrivateQuestionResponses } from '../utils/questionResponses'

import Header from './Header'

const StyledBreadcrumb = ({ title, index, progress }) => {
  return (
    <Anchor
      underline="never"
      key={index}
      className={`font-semibold ${
        index === progress
          ? 'text-doubleNickel-brand-500'
          : index < progress
          ? 'text-black'
          : 'text-doubleNickel-gray-500'
      }`}
    >
      {title}
    </Anchor>
  )
}

const ApplicationProgressBar = ({ application }) => {
  const { pathname } = useLocation()
  const currentScreen = pathname.split('/').pop()

  // Check if application has custom questions (PUBLIC short form questions
  // are not part of the DOT application, so they don't add a step)
  const hasCustomQuestions =
    filterPrivateQuestionResponses(application?.questionResponses).length > 0

  const calculateProgress = () => {
    switch (currentScreen) {
      case 'address-information':
        return 2
      case 'license-information':
        return 3
      case 'equipment-information':
        return 4
      case 'accident-history':
        return 5
      case 'employment-history':
        return 6
      case 'company-questions':
        return 7
      case 'consents':
        return hasCustomQuestions ? 8 : 7
      case 'sign':
        return hasCustomQuestions ? 9 : 8
      case 'submit':
        return hasCustomQuestions ? 10 : 9
      default:
        return 1
    }
  }
  const progress = calculateProgress()
  const totalSteps = hasCustomQuestions ? 9 : 8

  return (
    <>
      {/* Mobile: Progress bar in header */}
      <div className="flex w-full flex-col border-b-[1px] bg-white sm:hidden">
        <div className="flex w-full flex-row items-center gap-2 px-4 py-4">
          {Array.from({ length: totalSteps }).map((_, index) => (
            <Progress
              key={index}
              value={progress >= index + 1 ? 100 : 0}
              className="flex-1"
              radius="xs"
              size="sm"
            />
          ))}
        </div>
      </div>

      {/* Desktop: Header with logo and breadcrumb */}
      <div className="hidden sm:block">
        <Header companyId={application?.company?.companyId} />
        <div className="px-[5%]">
          <Breadcrumbs separator=">" separatorMargin="md" mt="xs">
            <StyledBreadcrumb
              title="Personal Information"
              index={1}
              progress={progress}
            />
            <StyledBreadcrumb title="Addresses" index={2} progress={progress} />
            <StyledBreadcrumb title="Licenses" index={3} progress={progress} />
            <StyledBreadcrumb title="Equipment" index={4} progress={progress} />
            <StyledBreadcrumb title="Accidents" index={5} progress={progress} />
            <StyledBreadcrumb
              title="Employment History"
              index={6}
              progress={progress}
            />
            {hasCustomQuestions && (
              <StyledBreadcrumb
                title="Company Questions"
                index={7}
                progress={progress}
              />
            )}
            <StyledBreadcrumb
              title="Consents"
              index={hasCustomQuestions ? 8 : 7}
              progress={progress}
            />
            <StyledBreadcrumb
              title="Signature"
              index={hasCustomQuestions ? 9 : 8}
              progress={progress}
            />
          </Breadcrumbs>
        </div>
      </div>
    </>
  )
}

export default ApplicationProgressBar
